/*
 * AGB consent gating (German compliance).
 * Unchecked checkbox keeps checkout buttons disabled and dynamic payment
 * containers inert. Works with Section Rendering API re-renders because
 * both checkbox and buttons are re-rendered in their default (gated) state.
 *
 * The `inert` attribute (in addition to the .agb-gated CSS class) blocks
 * keyboard focus and assistive tech on dynamic payment containers, not just
 * pointer events — payment buttons inside iframes could otherwise be
 * reached with Tab + Enter and bypass the consent gate.
 *
 * Session restore: once the customer has actively checked the box in this
 * session, re-renders (quantity change, line removal …) restore the checked
 * state automatically. Server-rendered markup still defaults to unchecked,
 * and a fresh session always starts unchecked.
 */
const AGB_CONSENT_KEY = 'kegret-agb-consent';

function applyAgbState(input) {
  const enabled = input.checked;
  const targets = (input.dataset.targets || '').split(',');

  targets.forEach((selector) => {
    if (!selector.trim()) return;
    document.querySelectorAll(selector.trim()).forEach((el) => {
      if (el.matches('button, [type="submit"], a')) {
        el.toggleAttribute('disabled', !enabled);
      }
      el.classList.toggle('agb-gated', !enabled);
      if (enabled) el.removeAttribute('inert');
      else el.setAttribute('inert', '');
    });
  });
}

document.addEventListener('change', (event) => {
  const input = event.target.closest('.agb-checkbox__input');
  if (!input) return;

  if (input.checked) sessionStorage.setItem(AGB_CONSENT_KEY, '1');
  else sessionStorage.removeItem(AGB_CONSENT_KEY);

  applyAgbState(input);
});

function enforceAgbGating() {
  document.querySelectorAll('.agb-checkbox__input').forEach(applyAgbState);
}

function restoreAgbConsent() {
  if (sessionStorage.getItem(AGB_CONSENT_KEY) !== '1') return;
  document.querySelectorAll('.agb-checkbox__input').forEach((input) => {
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

enforceAgbGating();

// Drawer / cart sections are swapped after cart operations; re-apply consent.
// MutationObserver is debounced: cart-countdown rewrites its DOM every second,
// which would otherwise trigger a full-document sweep at 1 Hz.
let agbObserverQueued = false;
const agbRenderObserver = new MutationObserver(() => {
  if (agbObserverQueued) return;
  agbObserverQueued = true;
  setTimeout(() => {
    agbObserverQueued = false;
    enforceAgbGating();
    restoreAgbConsent();
  }, 100);
});
agbRenderObserver.observe(document.body, { childList: true, subtree: true });
